<nav class="flex flex-col gap-3 mt-9 sm:flex-row">
	<a
		routerLink="/guides/subject"
		class="flex items-center justify-between white-header-btn btn-py-2"
	>
		Subject Degree Guides
		<uc-arrow-long-right-svg />
	</a>
	<a
		routerLink="/guides/city"
		class="flex items-center justify-between white-header-btn btn-py-2"
	>
		City Guides
		<uc-arrow-long-right-svg />
	</a>
	<a
		routerLink="/guides/career"
		class="flex items-center justify-between white-header-btn btn-py-2"
	>
		Career Guides
		<uc-arrow-long-right-svg />
	</a>
</nav>
